import { format } from 'date-fns';
import { DEFAULT_DATE_FORMAT_DATE_FNS } from '../../constants/dateRange';

export const formatToDefaultFormat = (date: Date): string => {
  return format(date, DEFAULT_DATE_FORMAT_DATE_FNS);
};
